<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :value.sync="queryParams.mpsVersion"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :value.sync="queryParams.productBroadCategory"
                selectType="select"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/listProductBroadCategory"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ pageSize: '99999' }"
              />
              <!-- <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.productBroadCategory"
                selectType="select"
                :selectData="productBroadCategoryOpinions"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="内外部">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.scpSupplierCategory"
                selectType="select"
                :selectData="listSideOpinions"
                :selectItem="{ value: 'attribute1', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :setParams="{scpSupplierCategory:queryParams.scpSupplierCategory}"
                :value.sync="queryParams.supplierId"
                selectType="selectSearch"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                searchParam="supplierName"
                :dropdown-match-select-width="false"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button :loading="isLoading" @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template slot="table">
      <a-tabs class="content-tabs" type="card" @change="tabOnchange">
        <a-tab-pane :force-render="true" key="1" tab="金额版">
          <div class="table-page-operator-wrapper action-btn">
            <a-button :loading="isCalculating" @click="handlCalculate" type="primary">刷新运算</a-button>
            <a-button @click="handleGoPlan" v-hasPermi="['scp:scpSopMpsSupplierCapacityLoad:edit']" >计划单调整</a-button>
            <a-button @click="handleExport" v-hasPermi="['scp:scpSopMpsSupplierCapacityLoad:export']" >导出报表</a-button>
          </div>
          <template>
            <div class="page-header-content">
              <a-spin :spinning="isLoading">
                <ls-api-table
                  ref="dataTable"
                  :columns="columns"
                  :multi-select="true"
                  :tableProps="tableProps"
                  rowKey="id"
                  :scroll="{ fixScreen: true, x: 1300 }"
                >
                  <!-- 月份 -->
                  <template slot="inputNumber" slot-scope="{ record, column }">
                    <!-- <span v-if="!isEdit || （currentId !== record.id">{{ record[column.dataIndex]?(record[column.dataIndex] + (filteredChildrenIndexKey.includes(column.dataIndex)?'%':'')):'' }}</span> -->
                    <a-input-number
                      :formatter="value => `${value}`"
                      v-if="isEdit && currentId === record.id && filteredChildrenAdjustmentAmountIndexKey.includes(column.dataIndex)"
                      v-model="record[column.dataIndex]"
                      size="small"
                    />
                    <span v-else>{{ record[column.dataIndex]?(record[column.dataIndex] + (filteredChildrenIndexKey.includes(column.dataIndex)?'%':'')):(record[column.dataIndex]===0?'0':'') }}</span>

                  <!-- <a-button @click="handleInputChange(record, column)"> 测试</a-button> -->
                  </template>
                  <!-- 操作 -->
                  <span slot="operation" slot-scope="{ record }">
                    <a v-if="(!isEdit || currentId !== record.id) && !record.countFlag" @click="handleEdit(record)" v-hasPermi="['scp:scpSopMpsSupplierCapacityLoad:edit']">编辑</a>
                    <a v-if="!record.countFlag && isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                    <a v-if="!record.countFlag && isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
                  </span>
                </ls-api-table>
              </a-spin>
            </div>
          </template>
        </a-tab-pane>
        <a-tab-pane :force-render="true" key="2" tab="工时版">
          <div class="table-page-operator-wrapper action-btn">
            <a-button @click="handleExport2" v-hasPermi="['scp:scpSopMpsSupplierCapacityLoad:export']" >导出报表</a-button>
          </div>
          <template>
            <div class="page-header-content">
              <a-spin :spinning="isLoading">
                <ls-api-table
                  ref="dataTable2"
                  :columns="columns2"
                  :multi-select="true"
                  :tableProps="tableProps2"
                  rowKey="id"
                  :scroll="{ fixScreen: true, x: 1300 }"
                >
                  <!-- 月份 -->
                  <template slot="inputNumber" slot-scope="{ record, column }">
                    <!-- <span v-if="!isEdit || （currentId !== record.id">{{ record[column.dataIndex]?(record[column.dataIndex] + (filteredChildrenIndexKey.includes(column.dataIndex)?'%':'')):'' }}</span> -->
                    <a-input-number
                      :formatter="value => `${value}`"
                      v-if="isEdit && currentId === record.id && filteredChildrenAdjustmentAmountIndexKey.includes(column.dataIndex)"
                      v-model="record[column.dataIndex]"
                      size="small"
                    />
                    <span v-else>{{ record[column.dataIndex]?(record[column.dataIndex] + (filteredChildrenIndexKey.includes(column.dataIndex)?'%':'')):(record[column.dataIndex]===0?'0':'') }}</span>

                  <!-- <a-button @click="handleInputChange(record, column)"> 测试</a-button> -->
                  </template>
                </ls-api-table>
              </a-spin>
            </div>
          </template>
        </a-tab-pane>
      </a-tabs>
    </template>

  </ls-table-layout>
</template>
  <script>
  import { generateLsTableResData } from '@/utils/util.js'
  import {
    apiScpSopSupplierCapacity,
    apiScpSopMpsSupplierCapacityLoad,
    apiScpCalculateCapacityLoad,
    apiGetScpSopSupplierCapacityLoadManHours,
    apiCalculateCapacityLoadIs
  } from '@/api/mps/basic-data/supplier-capacity-load.js'
  import moment from 'moment'
  export default {
    // eslint-disable-next-line
    name: 'Supplier-capacity-load',
    components: {
      },
    props: {
      id: {
        type: String,
        default: '1' // 设置默认值为'Hello from child'
      }
    },
    data () {
      return {
        isCalculating: false,
        filteredChildrenAdjustmentAmountIndexKey: [],
        filteredChildrenNoPercentIndexKey: [],
        filteredChildrenIndexKey: [],
        filteredChildrenAdjustmentAmountIndexKey2: [],
        filteredChildrenNoPercentIndexKey2: [],
        filteredChildrenIndexKey2: [],
        listSideOpinions: [],
        productBroadCategoryOpinions: [],
        isLoading: false,
        url: '/scp/scpSopFcInitialDeliveryRatio/import',
        isEdit: false,
        tableList: [],
        tableList2: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiScpSopSupplierCapacity, true),
          pageCurrent: true
        },
        // 表格配置
        tableProps2: {
          requestApi: generateLsTableResData(apiGetScpSopSupplierCapacityLoadManHours, true),
          pageCurrent: true
        },
        columns: [],
        columns2: [],
        columnsServe: [],
        columnsServe2: [],
        // 表格字段
        columnsNative: [
         {
            title: '供应商名称',
            dataIndex: 'supplierAbbreviation',
            width: 120,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '工艺大类',
            dataIndex: 'productBroadCategory',
            width: 150,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '内外部',
            dataIndex: 'scpSupplierCategory',
            width: 90,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '排序',
            dataIndex: 'order',
            width: 80,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '操作',
            fixed: 'right',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 120,
            ellipsis: true,
            align: 'center'
          }
        ],
        // 表格字段
        columnsNative2: [
         {
            title: '供应商名称',
            dataIndex: 'supplierAbbreviation',
            width: 120,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '工艺大类',
            dataIndex: 'productBroadCategory',
            width: 150,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '内外部',
            dataIndex: 'scpSupplierCategory',
            width: 90,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '排序',
            dataIndex: 'order',
            width: 80,
            ellipsis: true,
            align: 'center',
            fixed: 'left'
          }
        ],
        queryParams: {
            mpsVersion: undefined,
            productBroadCategory: undefined,
            scpSupplierCategory: undefined,
            supplierId: undefined,
            itemId: undefined
        }
      }
    },
    methods: {
      tabOnchange (val) {
        if (val === '1') {
          this.$refs.dataTable.initScrollY();
        } else if (val === '2') {
          this.$refs.dataTable2.initScrollY();
        }
      },
      handleGoPlan () {
        if (!this.queryParams.mpsVersion) {
          this.$message.error('必须选择版本')
          return
        }
        this.$router.push({ path: `/mps/mps-result/mps-plan-adjustment`, query: { mpsVersion: this.queryParams.mpsVersion, productBroadCategory: this.queryParams.productBroadCategory } })
      },
      async handlCalculate () {
        if (!this.queryParams.mpsVersion) {
            this.$message.error('请选择版本')
            return
        }
        const self = this
        self.isCalculating = true
        const isRefresh = await this.checkIsRefresh() // 校验是否存在正常执行的刷新
        self.isCalculating = false
        if (isRefresh) {
          this.$message.warning('操作失败，版本运行中')
          return false;
        }
        this.$confirm({
          title: '警告',
          content: `你确定要重新计算数据么?`,
          okText: '计算',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            self.isCalculating = true
            apiScpCalculateCapacityLoad({ mpsVersion: self.queryParams.mpsVersion }).then((response) => {
                self.isCalculating = false
              if (response.code === 200) {
                self.$message.success('已开始计算')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            }).catch(e => { self.isCalculating = false })
          }
        })
      },
      // 判断是否存在正在刷新，如存在未true，不能往下执行，false为无刷新，可以正常往下执行
      async checkIsRefresh() {
        const self = this
        let isRefresh = true
        await apiCalculateCapacityLoadIs({ mpsVersion: self.queryParams.mpsVersion }).then((response) => {
          isRefresh = (response?.code === 200) ? response?.data : true
        }).catch(e => {
          isRefresh = true
        })
        return isRefresh
      },
      handleExport () {
        this.download('scp/scpSopMpsSupplierCapacityLoad/export', {
          ...this.queryParams
        }, `MPS产能负荷（金额版）_${this.queryParams.mpsVersion}_${moment().format('YYYYMMDD')}.xlsx`)
      },
      handleExport2 () {
        this.download('scp/scpSopMpsSupplierCapacityLoadManHour/export', {
          ...this.queryParams
        }, `MPS产能负荷（工时版）_${this.queryParams.mpsVersion}_${moment().format('YYYYMMDD')}.xlsx`)
      },
        resetQuery () {
            this.queryParams = {
                mpsVersion: undefined,
                productBroadCategory: undefined,
                scpSupplierCategory: undefined,
                supplierId: undefined,
                itemId: undefined
            }
        },
        setCountPageData () {
            const tableList = this.$refs.dataTable.myDataSource
          var countObject = {
            id: -1,
            countFlag: true,
            productBroadCategory: '汇总'
          }
          this.filteredChildrenNoPercentIndexKey.forEach((noPercentItem) => {
            let countNumber = 0
            tableList.forEach((item) => {
                countNumber = countNumber + parseFloat(item[noPercentItem])
            })
            countObject[noPercentItem] = countNumber.toFixed(2)
           });
            tableList.push(countObject)
        },
        setCountPageData2 () {
            const tableList = this.$refs.dataTable2.myDataSource
          var countObject = {
            id: -1,
            countFlag: true,
            productBroadCategory: '汇总'
          }
          this.filteredChildrenNoPercentIndexKey2.forEach((noPercentItem) => {
            let countNumber = 0
            tableList.forEach((item) => {
                countNumber = countNumber + parseFloat(item[noPercentItem])
            })
            countObject[noPercentItem] = countNumber.toFixed(2)
           });
            tableList.push(countObject)
        },
        getLookupList (type, arr) {
            const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'MDM_ORG_SUPPLIER_CLASS') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            })
        },

     // 新增/修改框事件
       handleOk () {
          // this.onSearch()
        },

      // 编辑-保存
      async handleSave (record) {
        const isRefresh = await this.checkIsRefresh() // 校验是否存在正常执行的刷新
        if (isRefresh) {
          this.$message.warning('操作失败，版本运行中')
          return false
        }
        const recordCopy = JSON.parse(JSON.stringify(record))
        for (const key in recordCopy) {
          if (recordCopy[key]) {
            recordCopy[key] = recordCopy[key].toString();
          }
        }
        apiScpSopMpsSupplierCapacityLoad(recordCopy).then((response) => {
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      getTableInfo (id) {
        if (this.isLoading) {
          return
        }
        this.isLoading = true
        apiScpSopSupplierCapacity(id).then((response) => {
          this.isLoading = false
          if (response.code === 200) {
            this.tableList = response.data.rows
            this.tableList.forEach((obj, index) => {
              obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
            })
            this.$refs.dataTable.myDataSource = this.tableList
            const titles = response.data.title
            this.columnsServe = response.data.title
            // 生成新的对象数组，并为每个对象添加name属
            const newArray = titles.map((title) => {
              return {
                title: title.indexName,
                children: title.children.map((childrenTitle) => {
                  return {
                            title: childrenTitle.indexName,
                            dataIndex: childrenTitle.indexKey,
                            scopedSlots: { customRender: 'inputNumber' },
                            width: 120,
                            myTitle: childrenTitle.indexName,
                            align: 'center'
                          }
                })
              }
            })
            // 提取所有含有%的标题
            this.filteredChildrenIndexKey = []
            this.filteredChildrenNoPercentIndexKey = []
            this.filteredChildrenAdjustmentAmountIndexKey = []
            titles.forEach(item => {
            if (item.children && item.indexName.includes('%')) {
                item.children.forEach(child => {
                    this.filteredChildrenIndexKey.push(child.indexKey);
                });
            } else {
                item.children.forEach(child => {
                    this.filteredChildrenNoPercentIndexKey.push(child.indexKey);
                });
            }
            if (item.children && item.indexName.includes('调整金额')) {
                item.children.forEach(child => {
                    this.filteredChildrenAdjustmentAmountIndexKey.push(child.indexKey);
                });
            }
            });
            this.setCountPageData() // 增加统计数据

            const dynamicColumn = this.setNewColumn('order', this.columnsNative, newArray)
            this.columns = dynamicColumn
            this.$refs.dataTable.myPagination.total = response.data.total
            this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.data.total, this.$refs.dataTable.myPagination.pageSize)
          } else {
            this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
            this.$message.error(response.data.msg)
          }
        }).catch((error) => {
          this.isLoading = false
          // 处理 API 调用失败的情况
          console.error('API 调用失败: ', error);
        })
        apiGetScpSopSupplierCapacityLoadManHours(id).then(response => {
          console.log(response)
          this.isLoading = false
          if (response.code === 200) {
            this.tableList2 = response.data.rows
            this.tableList2.forEach((obj, index) => {
              obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
            })
            this.$refs.dataTable2.myDataSource = this.tableList2
            const titles = response.data.title
            this.columnsServe2 = response.data.title
            // 生成新的对象数组，并为每个对象添加name属
            const newArray = titles.map((title) => {
              return {
                title: title.indexName,
                children: title.children.map((childrenTitle) => {
                  return {
                            title: childrenTitle.indexName,
                            dataIndex: childrenTitle.indexKey,
                            scopedSlots: { customRender: 'inputNumber' },
                            width: 120,
                            myTitle: childrenTitle.indexName,
                            align: 'center'
                          }
                })
              }
            })
            // 提取所有含有%的标题
            this.filteredChildrenIndexKey2 = []
            this.filteredChildrenNoPercentIndexKey2 = []
            this.filteredChildrenAdjustmentAmountIndexKey2 = []
            titles.forEach(item => {
            if (item.children && item.indexName.includes('%')) {
                item.children.forEach(child => {
                    this.filteredChildrenIndexKey2.push(child.indexKey);
                });
            } else {
                item.children.forEach(child => {
                    this.filteredChildrenNoPercentIndexKey2.push(child.indexKey);
                });
            }
            if (item.children && item.indexName.includes('调整金额')) {
                item.children.forEach(child => {
                    this.filteredChildrenAdjustmentAmountIndexKey2.push(child.indexKey);
                });
            }
            });
            this.setCountPageData2() // 增加统计数据

            const dynamicColumn = this.setNewColumn('order', this.columnsNative2, newArray)
            this.columns2 = dynamicColumn
            this.$refs.dataTable2.myPagination.total = response.data.total
            this.$refs.dataTable2.pageTotal = this.$refs.dataTable2.getPageTotal(response.data.total, this.$refs.dataTable2.myPagination.pageSize)
          } else {
            this.tableList2 = []
            this.$refs.dataTable.myDataSource = this.tableList2
            this.$message.error(response.data.msg)
          }
        })
      },
      // 表单搜索
      onSearch () {
        if (!this.queryParams.mpsVersion) {
              this.$message.error('请输入版本')
              return
        }
        this.isEdit = false
         this.$refs.dataTable.searchParams = this.queryParams;
        // this.$refs.dataTable.getData();
        this.$refs.dataTable.myPagination.current = 1
        this.getTableInfo({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
      },
      /**
       * 在table 某个列的字段后增加列
       * key：列的字段名称
       * columnList 列表的列
       * insertColumnList 插入的新列
       *  */
      setNewColumn (key, columnList, insertColumnList) {
        const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
        const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
        if (index !== -1) {
          newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
        }
        return newArray
      },
      // 编辑
      async handleEdit (record, index) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return
        }
        const isRefresh = await this.checkIsRefresh() // 校验是否存在正常执行的刷新
        if (isRefresh) {
          this.$message.warning('操作失败，版本运行中')
          return false
        }
        this.isEdit = true
        this.currentId = record.id
      }
    },
    created () {
      // this.queryParams.mpsVersion = this.$route.query.id
      // this.getTableInfo()
      this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
       this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
    },
    mounted () {
      this.columns = this.columnsNative
      this.columns2 = this.columnsNative2
      // if (this.queryParams.mpsVersion) {
      //    this.onSearch()
      // }
    },
    activated() {
      if (this.$route.query.id) {
        this.queryParams.mpsVersion = this.$route.query.id
      }
      if (this.queryParams.mpsVersion) {
        this.onSearch()
      }
    }
  }
  </script>

  <style scoped lang="less">
  .content {
    display: flex;
    flex-direction: column;
  }
  .action-btn {
    display: flex;
    // flex-direction: row-reverse;
    padding: 8px 8px 8px 6px;
  }
  .table {
    flex: 1;
  }
  </style>
